import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../helpers/request';
import { keyPermitDoc } from './usePermitDocuments';

const deleteDoc = async ({ attachmentId }) => {
  return request.delete(
    `/Access/transport/attachments/${attachmentId}`,
    null,
    'При удалении документа пропуска произошла ошибка',
    'Error'
  );
};

const useDeleteDoc = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteDoc, {
    onSuccess: (data, { permitId }) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(keyPermitDoc(permitId));
    },
  });
};

export default useDeleteDoc;
